import { LOGIN_SUCCESS, LOGIN_FAIL } from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.loading, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return { ...action.payload.data };
    case LOGIN_FAIL:
      return state;
    default:
      return state;
  }
}
